import React, { createContext, useCallback, useContext, useState } from 'react'

const ModalContext = createContext(null)

export function ModalProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false)
    const [content, setContent] = useState(null)
    const [isPrewarm, setIsPrewarm] = useState(false)

    const openModal = useCallback((node) => {
        setContent(node)
        setIsOpen(true)
    }, [])

    const closeModal = useCallback(() => {
        setIsOpen(false)
        // delay content removal a tick so click-up events do not get swallowed
        setTimeout(() => setContent(null), 0)
    }, [])

    return (
        <ModalContext.Provider value={{ isOpen, content, openModal, closeModal, isPrewarm, setIsPrewarm }}>
            {children}
        </ModalContext.Provider>
    )
}

export function useModal() {
    const ctx = useContext(ModalContext)
    if (!ctx) throw new Error('useModal must be used within ModalProvider')
    return ctx
}


